import { showBreakerRound } from "services/util";

export const getNextPage = (
  quiz: any,
  customer: any,
  teams: any,
  progress: any
) => {
  const { section, page, round, position } = progress;
  //   console.log(section, page, round, position)
  const rounds = quiz.quizConfig?.format.rounds || 8;
  const questions = quiz.quizConfig?.format.questionCount || 10;
  const isCrossword = quiz.quizConfig?.format?.isCrossword || false;
  const hasBreaker = quiz.quizConfig?.format?.hasBreaker || false;
  const assignedPrizes = customer?.assignedPrizes || [];

  const nextIntroPage =
    progress.output.page === 3 ? 0 : progress.output.page + 1;
  if (progress.output.mode === "intro") {
    return {
      output: {
        mode: "intro",
        page: nextIntroPage,
      },
    };
  }

  switch (section) {
    case "welcome":
      return {
        section: "question",
        page: "intro",
        round: 1,
        position: 0,
      };

    // case "intro":
    //   if (page === "teams") {
    //     return { page: "rounds" };
    //   } else if(page === "rounds"){
    //     return { page: "prizes" };
    //   } else if(page === "prizes"){
    //     return { page: "ad" };
    //   } else if(page === "ad"){
    //     return { section: "welcome" };
    //   }
    //   break;

    case "question":
      if (page === "question") {
        if (position < questions - 1) {
          return { position: position + 1 };
        } else {
          if (isCrossword) {
            return {
              section: "crossword",
              page: "question",
              position: 0,
            };
          } else {
            if (hasBreaker && showBreakerRound(quiz.quizConfig, round)) {
              return {
                section: "breaker",
                page: "question",
                position: 0,
              };
            } else {
              return {
                section: "ad",
                position: 0,
              };
            }
          }
        }
      } else {
        return { page: "question" };
      }

    case "crossword":
      if (round === rounds) {
        if (page === "intro") {
          return {
            page: "answer",
          };
        } else if (page === "question") {
          return {
            section: "ad",
          };
        } else if (page === "answer") {
          return {
            section: "result",
            page: "crossword",
          };
        }
        break;
      } else {
        if (hasBreaker && showBreakerRound(quiz.quizConfig, round)) {
          return {
            section: "breaker",
            page: "question",
          };
        } else {
          return { section: "ad" };
          // return {
          //   section: "answer",
          //   page: "intro",
          // };
        }
      }

    case "breaker":
      if (round === 5 && page === "question") {
        return { section: "ad" };
      } else if (round === 5 && page === "answer-question") {
        return { page: "answer-answer" };
      } else if (round === 5 && page === "answer-answer") {
        return {
          section: "result",
          page: "intro",
        };
      } else {
        return { section: "ad" };
        // return {
        //     section: "result",
        //     page: "intro",
        //   };
      }

    case "ad":
      return {
        section: "answer",
        page: "intro",
        position: 0,
      };

    case "answer":
      if (page === "intro") {
        return { page: "question", position: 0 };
      } else {
        if (page === "answer") {
          if (position === questions - 1) {
            if (hasBreaker && round === 5) {
              return {
                section: "breaker",
                page: "answer-question",
              };
            } else {
              return {
                section: "result",
                page: "intro",
              };
            }
          } else {
            return {
              page: "question",
              position: position + 1,
            };
          }
        } else {
          return { page: "answer" };
        }
      }

    case "result":
      if (round === 1 && page !== "intro") {
        //round 1 (first round)
        if (page === "round") {
          return { page: "team" };
        } else {
          return {
            section: "question",
            page: "intro",
            round: round + 1,
            position: 0,
          };
        }
      } else if (round === 1 && page === "intro") {
        return {
          page: "round",
          position: 0,
        };
      } else if (round > 1 && round < rounds) {
        //rounds 2-7 (rounds in between first and last)
        if (page === "intro") {
          return { page: "round" };
        } else if (page === "round") {
          return { page: "aggregate" };
        } else if (page === "aggregate") {
          return { page: "team" };
        } else if (page === "team") {
          return {
            section: "question",
            page: "intro",
            round: round + 1,
            position: 0,
          };
        }
      } else if (round === rounds) {
        //round 8 (final round)
        if (page === "round") {
          if (isCrossword) {
            return {
              section: "crossword",
              page: "intro",
            };
          } else {
            return {
              section: "winner",
              page: "intro",
              position: 0,
            };
          }
        } else if (page === "intro") {
          return {
            page: "round",
            position: 0,
          };
        } else if (page === "crossword") {
          return {
            section: "winner",
            page: "intro",
            position: 0,
          };
        } else if (page === "aggregate-final") {
          return { page: "final" };
        }
      }
      break;

    case "winner":
      if (page === "intro") {
        if (assignedPrizes.length === 0) {
          return {
            section: "result",
            page: "aggregate-final",
          };
        } else {
          return { page: "prize" };
        }
      } else {
        if (
          position < assignedPrizes.length - 1 &&
          position < teams.length - 1
        ) {
          return { position: position + 1 };
        } else {
          return {
            section: "result",
            page: "aggregate-final",
          };
        }
      }

    default:
      break;
  }
};
